
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-product-avatar",
      function () {
        return require("private-next-pages/ai-product-avatar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-product-avatar"])
      });
    }
  